const DEFAULT_FORM_DATA = {
  loan: {
    purposeOfLoan: "",
    loanTermMonths: undefined,
    firstChargeMortgageValue: "",
    loanAmount: "",
    propertyPurchasePrice: "",
    estimatedPropertyValue: "",
    firstChargeLender: "",
    mortgageAgeYears: undefined,
    mortgageAgeMonths: undefined,
    remainingTermOfFirstChargeLoanYears: undefined,
    remainingTermOfFirstChargeLoanMonths: undefined,
    isInterestRateFixedForAnInitialPeriod: undefined,
    remainingTermOfInitialInterestRatePeriodMonths: undefined,
  },
};

export default DEFAULT_FORM_DATA;
